import {
    openModal,
    hideSpinner,
    showSpinner,
} from "@sitecorecomponents/BasicContent/Modal";
import { openLogin } from "../Login/login";
import { emailRules, setupFieldValidation } from "../formValidation";
import { showFormMessage } from "../formMessages";
import { resolveCallbackUrl } from "../callbackUrl";
import {sendResetPasswordEmailMutation, SendResetPasswordEmailResult} from "./forgotpassword.query";
import {fetchApiGraphQL, GraphQLError} from "@/utils/fetcher";


function showConfirmation(form: HTMLFormElement) {
    form.querySelectorAll<HTMLElement>(
        '[data-forgot-password-step="form"]',
    ).forEach((el) => el.classList.add("hidden"));

    form.closest("dialog")?.querySelectorAll<HTMLElement>("h1, .component.text, .component.content").forEach((el) => {
        el.hidden = true;
    });

    const receipt = form.querySelector<HTMLElement>(
        '[data-forgot-password-step="receipt"]',
    );
    receipt?.classList.remove("hidden");
    receipt?.classList.add("flex");
}

function setupForgotPasswordValidation(form: HTMLFormElement) {
    const email = form.querySelector<HTMLInputElement>("#Email");
    if (email) {
        setupFieldValidation(email, emailRules);
    }
}

function wireForgotPasswordLinks(
    form: HTMLFormElement,
    dialog: HTMLDialogElement | null,
) {
    form.querySelector<HTMLAnchorElement>("#open-login")?.addEventListener(
        "click",
        (e) => {
            e.preventDefault();
            dialog?.close();
            openLogin();
        },
    );
}
async function sendResetPassword(email: string, callBackUrl: string, form: HTMLFormElement): Promise<boolean> {
    let result: SendResetPasswordEmailResult;
    try {
        result = await fetchApiGraphQL<SendResetPasswordEmailResult>(
            sendResetPasswordEmailMutation,
            { email, callBackUrl },
            true
        );
    } catch (err) {
        const message = (err as GraphQLError)?.errors?.[0]?.message ?? "";
        if (message.toLowerCase().includes("email") || message.toLowerCase().includes("validation")) {
            showFormMessage(form, "invalid-email");
        } else {
            showFormMessage(form, "request-failed");
        }
        return false;
    }
    return result?.data?.sendResetPasswordEmail ?? false;
}



const handleSubmit = async (e: SubmitEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const email = (
        form.querySelector<HTMLInputElement>("#Email")?.value ?? ""
    ).trim();

    showFormMessage(form, null);

    if (emailRules.some((rule) => !rule.test(email))) {
        return;
    }

    const callBackUrl = resolveCallbackUrl(form);
    if (!callBackUrl) {
        showFormMessage(form, "request-failed");
        return;
    }
    showSpinner();
    const success = await sendResetPassword(email, callBackUrl, form);
    hideSpinner();

    if (!success) return;
    showConfirmation(form);
};

export const openForgotPassword = async () => {
    const form = document.createElement("form");

    openModal({
        name: "glemt-adgangskode",
        insertContent: (d) => {
            const innerHtml = d.innerHTML;
            d.innerHTML = "";

            form.innerHTML = innerHtml;
            form.onsubmit = handleSubmit;
            d.appendChild(form);

            setupForgotPasswordValidation(form);
            wireForgotPasswordLinks(form, d.closest("dialog"));
        },
        onClose: () => {
            form.onsubmit = null;
        },
    });
};
